import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/** @deprecated - this is moved to libs */
@Pipe({
    name: 'prettyPrice',
})
export class PrettyPricePipe implements PipeTransform {
    private seperator: string = '.';

    constructor(private domSanitizer: DomSanitizer) { }

    transform(price: number): SafeHtml {
        if (!price) {
            return this.domSanitizer.bypassSecurityTrustHtml(`0<span>,00</span>`);
        }

        const newPrice = this.roundUp(price);

        if (this.hasNoDecimals(`${newPrice}`)) {
            return this.domSanitizer.bypassSecurityTrustHtml(`${newPrice}<span>,00</span>`);
        }

        const parts = `${newPrice}`.split(this.seperator);
        const decimals = parts[1].padEnd(2, '0').split('').slice(0, 2).join('');

        return this.domSanitizer.bypassSecurityTrustHtml(`${parts[0]}<span>,${decimals}</span>`);
    }

    private roundUp(number: number): number {
        const newNumber = Number((Math.abs(number) * 100).toPrecision(15));
        return (Math.round(newNumber) / 100) * Math.sign(number);
    }

    private hasNoDecimals(price: string = ''): boolean {
        return false === price.includes(this.seperator);
    }
}
